export default __webpack_public_path__ + "static/media/DTV-Social-Campaign-1.91a0c026.png";